import { render, staticRenderFns } from "./BatchGenerationCenter.vue?vue&type=template&id=77e64aa1&scoped=true"
import script from "./BatchGenerationCenter.vue?vue&type=script&lang=js"
export * from "./BatchGenerationCenter.vue?vue&type=script&lang=js"
import style0 from "./BatchGenerationCenter.vue?vue&type=style&index=0&id=77e64aa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e64aa1",
  null
  
)

export default component.exports